import { render, staticRenderFns } from "./google-signin.vue?vue&type=template&id=1b4b2f46&scoped=true"
import script from "./google-signin.vue?vue&type=script&lang=js"
export * from "./google-signin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4b2f46",
  null
  
)

export default component.exports